exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blocked-alarms-date{color:white;opacity:.6}.blocked-alarms-time{color:white;white-space:nowrap}.blocked-alarms-reason-additional{opacity:.6}.blocked-alarms-text{color:white}\n", ""]);

// exports
